"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyBrandWrapper = void 0;
var material_1 = require("@mui/material");
var Link_1 = __importDefault(require("shared/components/Link"));
exports.CompanyBrandWrapper = (0, material_1.styled)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        fontWeight: theme.typography.fontWeightMedium,
        padding: theme.spacing(1.5),
        margin: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        maxWidth: 500,
        '&:hover': {
            textDecoration: 'none',
        },
        ':focus-visible': __assign(__assign({}, theme.focusVisibleStyles), theme.focusVisibleLinkStyles),
    });
});
